import React from 'react';

import {
    Button,
    Spinner,
    css,
} from "@bdfx/fukit"

import {apiExportAuditProducts} from "@bdfx/audit-api"
import {exportFields, fields, commonFields } from "../result-detail/products"


const ExportButton = ({auditId, index,...props}) => {
  const [loading, setLoading] = React.useState(false)
    const f = [...commonFields, ...fields[index], ...exportFields].map(index => index.toLowerCase())
    const exportProducts = () => {
      setLoading(true)
      apiExportAuditProducts(auditId, {
        filter: { [index]: 1 },
        fields: f,
      }).then(r => {
        if(r.data?.data?.download_url) {
          window.open(r.data?.data?.download_url)
        }
        setLoading(false)
      }).catch(e => {
          setLoading(false)
          console.error(e)
      })
    }

    return <Style secondary={true} 
                className={auditId === "example" ? "disabled" : ""} 
                color="#3c3c3c"
                size="small" 
                onClick={exportProducts} 
                icon="download-light"
                title={auditId === "example" ? "V ukázkovém auditu není dostupný export produktů" : ""}
                {...props}>
                    {loading ? <Spinner type="bubbles" size={15} /> : "Export"}
            </Style>
}

const Style = css(Button)({
    width: "110px",
    "&.disabled": {
        opacity: 0.2,
        cursor: "help",
    }
})



export default ExportButton